"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useRef } from "react";
import { useInfiniteScroll } from "../../../../hooks/useInfiniteScroll";
import UnifiedWavesListEmpty from "../waves/UnifiedWavesListEmpty";
import { UnifiedWavesListLoader } from "../waves/UnifiedWavesListLoader";
import WebUnifiedWavesListWaves from "./WebUnifiedWavesListWaves";
import type { MinimalWave } from "@/contexts/wave/hooks/useEnhancedWavesListCore";
interface WebUnifiedWavesListProps {
  readonly waves: MinimalWave[];
  readonly fetchNextPage: () => void;
  readonly hasNextPage: boolean | undefined;
  readonly isFetching: boolean;
  readonly isFetchingNextPage: boolean;
  readonly onHover: (waveId: string) => void;
  readonly scrollContainerRef: React.RefObject<HTMLElement | null>;
  readonly isCollapsed?: boolean | undefined;
  readonly showProfileFeedShortcut?: boolean | undefined;
}
const WebUnifiedWavesList: React.FC<WebUnifiedWavesListProps> = props => {
  const $ = _c(17);
  const {
    waves,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    onHover,
    scrollContainerRef,
    isCollapsed: t0,
    showProfileFeedShortcut: t1
  } = props;
  const isCollapsed = t0 === undefined ? false : t0;
  const showProfileFeedShortcut = t1 === undefined ? true : t1;
  const sentinelRef = useRef(null);
  useInfiniteScroll(hasNextPage, isFetchingNextPage, fetchNextPage, scrollContainerRef, sentinelRef, "100px");
  let t2;
  if ($[0] !== isCollapsed || $[1] !== onHover || $[2] !== scrollContainerRef || $[3] !== showProfileFeedShortcut || $[4] !== waves) {
    t2 = <WebUnifiedWavesListWaves waves={waves} onHover={onHover} scrollContainerRef={scrollContainerRef} isCollapsed={isCollapsed} showProfileFeedShortcut={showProfileFeedShortcut} sentinelRef={sentinelRef} />;
    $[0] = isCollapsed;
    $[1] = onHover;
    $[2] = scrollContainerRef;
    $[3] = showProfileFeedShortcut;
    $[4] = waves;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = isFetching && waves.length === 0;
  let t4;
  if ($[6] !== isFetchingNextPage || $[7] !== t3) {
    t4 = <UnifiedWavesListLoader isFetching={t3} isFetchingNextPage={isFetchingNextPage} />;
    $[6] = isFetchingNextPage;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isFetching || $[10] !== isFetchingNextPage || $[11] !== waves) {
    t5 = <UnifiedWavesListEmpty sortedWaves={waves} isFetching={isFetching} isFetchingNextPage={isFetchingNextPage} />;
    $[9] = isFetching;
    $[10] = isFetchingNextPage;
    $[11] = waves;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t2 || $[14] !== t4 || $[15] !== t5) {
    t6 = <div className="tw-h-full tw-bg-black tw-py-4"><div className="tw-w-full">{t2}{t4}{t5}</div></div>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default WebUnifiedWavesList;